import type { Component } from '../router';
import { SurfaceGate } from '../components/SurfaceGate';
import { t } from '../i18n';

class PhoneCapture implements Component {
  private root: HTMLElement | null = null;
  mount(host: HTMLElement): void {
    const wrap = document.createElement('div');
    wrap.className = 'capture';

    const lead = document.createElement('h1');
    lead.className = 'capture__lead';
    lead.textContent = t('home.welcome');

    const sub = document.createElement('p');
    sub.className = 'capture__sub';
    sub.textContent = t('home.captureSub');

    const card = document.createElement('article');
    card.className = 'capture-card';
    const title = document.createElement('h2');
    title.className = 'capture-card__title';
    title.textContent = t('home.newRecord');
    const body = document.createElement('p');
    body.className = 'capture-card__body';
    body.textContent = t('home.newRecordBody');
    const cta = document.createElement('a');
    cta.className = 'capture-card__cta';
    cta.href = '/work-orders';
    cta.textContent = t('home.begin');
    card.append(title, body, cta);

    wrap.append(lead, sub, card);
    host.appendChild(wrap);
    this.root = wrap;
  }
  unmount(): void {
    this.root?.remove();
    this.root = null;
  }
}

// The desk home. The assistant is no longer a panel here: it is the
// shell-level prompt surface under the top bar on every desk route (FE-033).
class DesktopHome implements Component {
  private root: HTMLElement | null = null;

  mount(host: HTMLElement): void {
    const wrap = document.createElement('div');
    wrap.className = 'deskhome';

    const lead = document.createElement('h1');
    lead.className = 'deskhome__lead';
    lead.textContent = t('home.welcomeBack');

    const activity = document.createElement('section');
    activity.className = 'panel';
    const title = document.createElement('h2');
    title.className = 'panel__title';
    title.textContent = t('home.recentActivity');
    const empty = document.createElement('div');
    empty.className = 'empty-state';
    empty.textContent = t('home.recentEmpty');
    activity.append(title, empty);

    wrap.append(lead, activity);
    host.appendChild(wrap);
    this.root = wrap;
  }

  unmount(): void {
    this.root?.remove();
    this.root = null;
  }
}

export function HomePage(): Component {
  // The capture surface (phone) gets the field-capture hero; the desk surface
  // (tablet + desktop) gets the multi-pane office home. SurfaceGate routes
  // tablet → desk, so there's no third branch to keep in sync.
  return new SurfaceGate({
    capture: () => new PhoneCapture(),
    desk: () => new DesktopHome(),
  });
}
